const barGraphics = {
  lbldaterange: "Escoja Rango de Fechas",
  zones: {
    zone: "Zona",
    smooth: "Optima",
    warning: "Advertencia",
    alarm: "Alarma"
  },
  lblinspections: "Inspecciones",
  buttons: {
    cancel: "Cancelar"
  }
};
export default barGraphics;
